import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import merge from 'lodash.merge';
import defaultMessages from './index';
import Logger from '../../../player/utils/logger';

export const LocaleContext = React.createContext({});

export default function LocaleProvider(props) {
  const {
    children,
    locale, providedMessages,
  } = props;

  const [messages, setMessages] = useState({});

  useEffect(() => {
    const allMessages = merge({}, defaultMessages, providedMessages);
    const localeMessages = allMessages[locale];
    if (!localeMessages) {
      Logger.error(`Can't find messages for locale ${locale}, will use en as fallback`);
    }
    setMessages({
      ...allMessages.en,
      ...(localeMessages || allMessages.en),
    });
  }, [locale, providedMessages]);

  return (
    <LocaleContext.Provider value={messages}>
      {children}
    </LocaleContext.Provider>
  );
}

LocaleProvider.propTypes = {
  locale: PropTypes.string,
  providedMessages: PropTypes.object,
  children: PropTypes.node,
};

LocaleProvider.defaultProps = {
  locale: 'en',
};
